var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00683594H513V114.216H0V-0.00683594Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 114.216H513V228.438H0V114.216Z",
    fill: "#E40112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 228.438H513V342.661H0V228.438Z",
    fill: "#07893F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 220.423C309.07 220.423 351.686 177.807 351.686 125.237C351.686 72.6678 309.07 30.0518 256.5 30.0518C203.93 30.0518 161.314 72.6678 161.314 125.237C161.314 177.807 203.93 220.423 256.5 220.423Z",
    fill: "#E40112"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342.668,
    fill: "white",
    transform: "translate(0 -0.00683594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/MW.7bd2338a7324c06a9666171beaca8300.svg";
export { ForwardRef as ReactComponent };